import { VirtualLinkProvider } from '../types.js'

export function detectProvider(url: string): VirtualLinkProvider {
  if (url.includes('zoom.us')) {
    return VirtualLinkProvider.Zoom
  }
  if (url.includes('meet.google.com') || url.includes('g.co')) {
    return VirtualLinkProvider.Meet
  }
  if (
    url.includes('youtube.com') ||
    url.includes('youtu.be') ||
    url.includes('m.youtube.com')
  ) {
    return VirtualLinkProvider.Youtube
  }
  if (url.includes('teams.microsoft.com')) {
    return VirtualLinkProvider.Teams
  }
  return VirtualLinkProvider.Custom
}

export const generateGoogleMapsUrl = (
  latitude: number,
  longitude: number,
  placeId: string,
) => {
  /**
   * https://developers.google.com/maps/documentation/urls/get-started#:~:text=query%20(required)%3A%20Defines%20the,using%20latitude/longitude%20coordinates.
   */
  return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}&query_place_id=${placeId}`
}
